import { ConfigurationService } from './services';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { DataexchangeService } from './services/dataexchange.service';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from './services/user.service';
import { initApplicationSelector } from './store/Application/ApplicationSelector';
import { ApplicationState } from './store/Application/ApplicationReducer';
import { Store } from '@ngrx/store';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, OnDestroy {

  ioConnection: any;
  title = 'MatchBoard';
  defaultLanguage = this.configurationService.getLocale();

  subscriptions: Array<Subscription>;

  isOnBehalfUser: boolean;

  constructor(
    private translateService: TranslateService,
    private readonly configurationService: ConfigurationService,
    private dataexchangeService: DataexchangeService,
    private userService: UserService,
    private readonly titleService: Title,
    private readonly applicationStore: Store<ApplicationState>
    ) {
    this.translateService.setDefaultLang(this.defaultLanguage);
    this.subscriptions = new Array<Subscription>();
    // this.socket$ = new Subject('ws://localhost:3000');
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  ngOnInit(): void {
    this.applicationStore.select(initApplicationSelector).subscribe((config) => {
      this.titleService.setTitle(config.title);
    });
    if (this.userService.isSuperUser()) {
      this.subscriptions.push(
        this.dataexchangeService.selectedOnBehalfUser.subscribe((value) => {
          if (value) {
            document.getElementById('mainWrapper').style.backgroundColor = '#ffff0057';
          }
        })
      );
    }
  }

}
